import httpRequest from '../../utils/httpRequest'
import { setLoading } from '../global/action'

export const SET_TRANSACTION_HISTORY = 'SET_TRANSACTION_HISTORY'

export const SET_FETCH_TRANSACTION = 'SET_FETCH_TRANSACTION'

export const setTransactionHistory = data => dispatch => {
  dispatch({ type: SET_TRANSACTION_HISTORY, data })
}

export const setFetchTransaction = data => dispatch => {
  dispatch({ type: SET_FETCH_TRANSACTION, data })
}

export const getTransactions = params => async dispatch => {
  try {
    // dispatch(setFetchTransaction(true))
    dispatch(setLoading(true))
    const data = await httpRequest.getTransactions(params)
    dispatch(setTransactionHistory(data))
    // dispatch(setFetchTransaction(false))
    dispatch(setLoading(false))
  } catch (err) {
    console.log(`status:${err.status} message: ${err.statusText}`)
    dispatch(setFetchTransaction(false))
    dispatch(setLoading(false))
  }
}
